import { Injectable, Inject } from 'ng-metadata/core';
import { MappingTablesCache } from '../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../nddUtils/configurationUtil.service';
import { getVid, isCitationTrailsFilterByAvailability } from '../../appConfig/appConfigForward';
import { preventStateReload } from '../../infra/annotations';


@Injectable()
export class CitationTrailsExpandButtonService {

    private _expandMyResultsForCitationTrail:boolean = false;
    private CITATION_TRAIL_FILTER_RESULTS = "citation_trail_filter_results";

    constructor(
        private mappingTablesCache: MappingTablesCache,
        private configurationUtil: ConfigurationUtil,
        @Inject('$location') private $location: ng.ILocationService,) {

        this.setInitialToggleValue();
    }

    private setInitialToggleValueFromMT(){
        if (this.isSuprima){     // Primo VE
            if (this.isFeatureFlagEnabled){
                //the variable name is expandMyResults, while the BO configuration is Filter By Availability. Expand is the opposite of Filter, so we're using "!"
                this.expandMyResultsForCitationTrail = !isCitationTrailsFilterByAvailability();
            }    
        } else {                 // Classic Primo
            this.expandMyResultsForCitationTrail = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VIEW_PROPERTIES, { target: 'false', source1: getVid(), source2: this.CITATION_TRAIL_FILTER_RESULTS }).length > 0;
        }
    }

    private setInitialToggleValue(){
        /* Setting the initial value from the URL parameter. If no URL pararmeter, taking from MT */
        let citationTrailFilterByAvailabilityParamFromUrl=this.$location.search().citationTrailFilterByAvailability;
        switch (citationTrailFilterByAvailabilityParamFromUrl) {
            case 'false':
                this.expandMyResultsForCitationTrail = true;  
                break;
            case 'true':
                this.expandMyResultsForCitationTrail = false;  
                break;
            default:
                this.setInitialToggleValueFromMT(); // in case there's no URL param
        }  
    }

    @preventStateReload
    public addParamToUrl(paramValue: string) {
        this.$location.search('citationTrailFilterByAvailability', paramValue);
    }


    get isSuprima(){
        return this.configurationUtil.isSuprima();
    }

    get isFeatureFlagEnabled(){
        return this.configurationUtil.getFeatureFlag("configuration_to_use_filtered_or_expand_search_for_citation_trail");
    }

    get expandMyResultsForCitationTrail (){
        return this._expandMyResultsForCitationTrail;
    }

    set expandMyResultsForCitationTrail (value){
        this._expandMyResultsForCitationTrail = value;
    }



}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsExpandButton.service.ts